import { render, staticRenderFns } from "./countryForm.vue?vue&type=template&id=923b4896"
import script from "./countryForm.vue?vue&type=script&lang=js"
export * from "./countryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports